import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ServiceDepartmentBookingParamsRecord } from '@navio/nsdk';
import { FieldErrorMessage, NoddiCard, NoddiCheckbox } from 'noddi-ui-web';

export const TermsAndConditions = ({
  hasAcceptedTermsAndConditions,
  handleTermsAcceptance,
  termsError,
  serviceDepartmentForBooking
}: {
  hasAcceptedTermsAndConditions: boolean;
  handleTermsAcceptance: (checked: boolean) => void;
  termsError: string | null;
  serviceDepartmentForBooking: ServiceDepartmentBookingParamsRecord;
}) => {
  const brandName = serviceDepartmentForBooking.serviceOrganization.name;
  const termsErrorId = 'terms-and-conditions-error';
  return (
    <div className='flex flex-col gap-2'>
      <NoddiCard contentClassName='flex flex-col gap-2'>
        <NoddiCheckbox
          id='terms-and-conditions'
          defaultChecked={hasAcceptedTermsAndConditions}
          onCheckedChange={handleTermsAcceptance}
          aria-invalid={termsError ? true : undefined}
          aria-describedby={termsError ? termsErrorId : undefined}
          label={
            <span>
              <Trans>I accept {brandName}'</Trans>
              <a
                href={serviceDepartmentForBooking.serviceOrganization.termsAndConditionsUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='ml-1 text-foreground underline'
                onClick={(e) => e.stopPropagation()}
              >
                <Trans>terms and conditions</Trans>
                <span className='sr-only'> ({t`opens in a new tab`})</span>
              </a>
            </span>
          }
        />
        {termsError && <FieldErrorMessage id={termsErrorId} errorMessage={termsError} />}
      </NoddiCard>
    </div>
  );
};
